import { ColumnDataType } from 'components/elements/table/type';

export const columns = (t) => [
  {
    header: t('common:other'),
    accessorKey: 'activityName',
    minSize: 250,
    maxSize: 250,
    dataType: ColumnDataType.text,
  },
  {
    header: t('common:type'),
    accessorKey: 'type',
    minSize: 150,
    maxSize: 150,
    dataType: ColumnDataType.null,
  },
  {
    header: t('common:date'),
    accessorKey: 'date',
    minSize: 150,
    maxSize: 150,
    dataType: ColumnDataType.date,
  },
  {
    header: t('common:price'),
    accessorKey: 'price',
    minSize: 150,
    maxSize: 150,
    dataType: ColumnDataType.number,
    minNumber: 0,
  },
  {
    header: t('common:qty'),
    accessorKey: 'qty',
    minSize: 150,
    maxSize: 150,
    dataType: ColumnDataType.number,
    minNumber: 0,
  },
  {
    header: t('common:total_price'),
    accessorKey: 'totalPrice',
    minSize: 150,
    maxSize: 150,
    dataType: ColumnDataType.number,
    minNumber: 0,
  },
  {
    header: t('common:description'),
    accessorKey: 'description',
    minSize: 150,
    maxSize: 150,
    dataType: ColumnDataType.text,
  },
];
